import {mtop} from '../../utils';
import { message } from 'antd';

export default {
  namespace: 'accountReceive',
  state: {
    receiveInfo: {
      shareholderList: []
    },
    defaultItemData: {
      shareholderType: 'COMPANY',// 股东类型：[企业股东， 个人股东]['COMPANY', 'PERSON']
      shareholderName: '',// 股东名称
      licenseType: 'ALL_IN_ONE',// 企业类型：[三证合一， 非三证合一]['ALL_IN_ONE', 'NOT_IN_ONE'
      validityType: 'SHORT_TERM',// 证件类型：[短期， 长期]['SHORT_TERM', 'LONG_TERM'] 身份证、统一社会信用代码、营业执照这三个公用一个证件类型
      startDate: '',// 开始日期，身份证、统一社会信用代码、营业执照这三个公用一个开始结束
      expireDate: '',// 结束日期，
      idCardNO: '',// 身份证号码
      socialCode: '',// 统一信用代码
      licenseNo: '',// 营业执照编号
      organizationCode: '',// 机构组织代码
      organizationStart: '',// 机构组织代码开始日期
      organizationExpire: '',// 机构组织代码结束日期
      organizationValidityType:'SHORT_TERM',// 组织机构证件类型['SHORT_TERM', 'LONG_TERM']
      taxRegistration: '',// 税务登记证号码
      taxRegistrationStart: '',// 税务登记证号码开始日期
      taxRegistrationExpire: '',// 税务登记证号码结束日期
      taxRegistrationValidityType:'SHORT_TERM',// 税务登记证件类型['SHORT_TERM', 'LONG_TERM']
      shareholdingRatio: '',// 持股比例
    },
    itemKey: 0,
    codeStatus: false,
    stepTwoSubmitRes: {},
    bankList: [],
    bankBranchList: [],
  },

  reducers: {
    setReceiveInfo(state, {payload: receiveInfo}) {
      if (!receiveInfo.shareholderList || !receiveInfo.shareholderList.length ) {
        receiveInfo.shareholderList = [ state.defaultItemData ];
      }
      let itemKey = receiveInfo.shareholderList.length - 1;
      receiveInfo.shareholderList.forEach((item, index) => {
        item.itemKey = index;
      });
      return {
        ...state,
        receiveInfo,
        itemKey
      };
    },
    // 删除一条股东信息
    removeShareholder(state, {payload: itemKey}) {
      state.receiveInfo.shareholderList = state.receiveInfo.shareholderList.filter(item => item.itemKey !== itemKey);
      return {
        ...state,
        receiveInfo:{...state.receiveInfo}
      }
    },
    // 增加一条股东信息
    addShareholder(state) {
      let itemKey = state.itemKey + 1;
      const itemData = {...state.defaultItemData, itemKey};
      state.receiveInfo.shareholderList = [...state.receiveInfo.shareholderList, itemData];
      return {
        ...state,
        itemKey
      }
    },
    // 更新一条股东信息
    updateShareholder(state, {payload: itemData}) {
      let { receiveInfo } = state;
      let { shareholderList } = receiveInfo;
      const ind = shareholderList.findIndex(item => item.itemKey === itemData.itemKey);
      shareholderList[ind] = itemData;
      receiveInfo = {...receiveInfo, shareholderList};
      return {
        ...state,
        receiveInfo

      }
    },
    setCodeStatus(state, { payload: codeStatus }) {
      return {
        ...state,
        codeStatus,
      };
    },
    setStepTwoSubmitRes(state, { payload: stepTwoSubmitRes }) {
      return {
        ...state,
        stepTwoSubmitRes,
      };
    },
    setBankList(state, { payload: result = {} }) {
      const { result: bankList = [] } = result;
      return {
        ...state,
        bankList
      };
    },
    setBankBranchList(state, { payload: result = {} }) {
      const { result: bankBranchList = [] } = result;
      return {
        ...state,
        bankBranchList
      };
    },
  },
  effects: {
    // 获取收款账户信息
    * getReceiveInfo({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'register.providerinfo.steptwo.get', {
          ...payload,
        });
        yield put({type: 'setReceiveInfo', payload: response});
      } catch (error) {
        message.error(error.msg);
        yield put({type: 'setReceiveInfo', payload: {}});
      }
    },
    // 第二步提交
    * confirmReceive({payload}, {put, call}) {
      try {
        // const response = yield call(mtop, 'register.steptwo.submit', {
        const response = yield call(mtop, 'register.apply.submit', {
          ...payload,
        });
        yield put({type: 'setStepTwoSubmitRes', payload: response});
      } catch (error) {
        yield put({type: 'setStepTwoSubmitRes', payload: { status: error.msg}});
      }
    },
    // 验证短信校验码
    * checkVerifyCode({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'register.steptwo.verifycode', {
          ...payload,
        });
        yield put({type: 'setCodeStatus', payload: true});
      } catch (error) {
        yield put({type: 'setCodeStatus', payload: error.msg});
      }
    },
    // 获取银行列表
    * getBankList({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'register.bankInfo.list', {
          ...payload,
        });
        yield put({type: 'setBankList', payload: response});
      } catch (error) {
        message.error(error.msg);
        yield put({type: 'setBankList', payload: false});
      }
    },
    // 获取支行列表
    * getBankBranchList({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'register.bankInfo.list', {
          ...payload,
        });
        yield put({type: 'setBankBranchList', payload: response});
      } catch (error) {
        message.error(error.msg);
        yield put({type: 'setBankBranchList', payload: false});
      }
    },
  },
};


// WEBPACK FOOTER //
// ./src/models/account/receive.js